import { PageMetaDto } from "../../dto/page.metadata.dto";
import { useTranslation } from "react-i18next";
import "./GenericTable.scss";

interface PaginationProps {
  meta: PageMetaDto;
  pageIndex: number;
  pageCount: number;
  pageSize: number;
  pageSizeOptions: number[];
  canPreviousPage: boolean;
  canNextPage: boolean;
  setPageIndex: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  setPageSize: (size: number) => void;
}

export const TablePagination: React.FC<PaginationProps> = ({
  meta,
  pageIndex,
  pageCount,
  pageSize,
  pageSizeOptions,
  canPreviousPage,
  canNextPage,
  setPageIndex,
  previousPage,
  nextPage,
  setPageSize,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex justify-between">
        <div className="pagination-controls row">
          <button onClick={() => setPageIndex(0)} disabled={!canPreviousPage}>
            {"<<"}
          </button>
          <button onClick={previousPage} disabled={!canPreviousPage}>
            {"<"}
          </button>
          <button onClick={nextPage} disabled={!canNextPage}>
            {">"}
          </button>
          <button
            onClick={() => setPageIndex(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>
          <span>
            {t('page')}{" "}
            <strong>
              {pageIndex + 1} of {pageCount}
            </strong>
          </span>
          <span>
            | {t('go_to_page')}:{" "}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                if (page >= 0 && page < pageCount) {
                  setPageIndex(page);
                }
              }}
              className="page-input"
              min={1}
              max={pageCount}
            />
          </span>
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="page-size-select"
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {t('show')} {size}
              </option>
            ))}
          </select>
        </div>
        <div className="flex px-3">
          <div className="py-5 font-semibold">{meta?.itemCount} {t('records')}</div>
        </div>
      </div>
    </>
  );
};
